export default "__VITE_ASSET__Ce0Bc3kB__"